import Vue from "vue";
import VueRouter from "vue-router";

/**
 * Login
 */
// import HomeLogin from '../views/login/HomeLogin.vue'
// import PwdRecovery from '../views/login/pwdRecovery.vue'
// import PwdChange from '../views/login/pwdChange.vue'
// import EmailRecovery from '../views/login/emailRecovery.vue'

/**
 * On boarding
 */

import HomeOnboarding from "../views/onboarding/HomeOnboarding.vue";
import SelectModule from "../views/onboarding/selectModule.vue";

/**
 * Request
 */
import HomeRequest from "../views/requests/HomeRequest.vue";
import ConsulRequest from "../views/requests/consulRequest.vue";

/**
 * Demands
 */
import AllDemands from "../views/demands/AllDemands.vue";
import AllDemandsBP from "../views/demands/AllDemandsBP.vue";

/**
 * Dashboard
 */
import Dashboard from "../views/dashboard/Dashboard.vue";
import DashboardPermisos from "../views/dashboard/DashboardPermisos.vue";
import DashboardDerechos from "../views/dashboard/DashboardDerechos.vue";

/**
 * Letter
 */
import EditLetter from "../views/editLetter/homeLetter.vue";
import TemplateLetter from "../views/editLetter/TemplateLetter.vue";

/**
 * Approval
 */
import Approval from "../views/approvals/HomeApproval.vue";
import Approver from "../views/approvals/approver.vue";

/**
 * Free User
 */
import FreeUser from "../views/freeUser/freeUser.vue";
import InfoRequest from "../views/freeUser/infoRequest.vue";
import Absenteeism from "../views/freeUser/absenteeism.vue";

/**
 * Help
 */
import Help from "../views/help/homeHelp.vue";

/**
 * Profile Admin
 */
import Profile from "../views/login/profileAdmin.vue";

/**
 * Settle
 */
import Settle from "../views/settle/homeSettle.vue";

/**
 * Right Petition
 */
import Reception from "../views/responsibles/reception.vue";
import RequestInfo from "../views/responsibles/requestInfo.vue";
import Response from "../views/responsibles/response.vue";
import Close from "../views/responsibles/close.vue";
import RightPetition from "../views/responsibles/rightPetition.vue";
import listRP from "../views/responsibles/listRP.vue";

/**
 * Forum
 */
import Forum from "../views/forum/forum.vue";
import Informer from "../views/forum/informer.vue";

/**
 *
 *
 *
 * DISCIPLINARY PROCESSES
 *
 *
 *
 */
/**
 * HOME
 */
import HomeProcesses from "../views/processes/homeProcesses.vue";
import Process from "../views/processes/process.vue";
import ProcessDetail from "../views/processes/processDetail.vue";
import ProcessDashboard from "../views/processes/processDashboard.vue";
import AllProcess from "../views/processes/allProcess.vue";

/**
 * test
 */
import Test from "../views/test.vue";

/**
 * tipshiftReport
 */
import tipshiftReport from "../views/tipshiftReport/tipshiftReport.vue";

/**
 * tipsemployee
 */
import tipsemployee from "../views/tipsemployee/tipsemployee.vue";

/**
 * tipsreporthistory
 */
import tipsreporthistory from "../views/tipsreporthistory/tipsreporthistory.vue";
import tipsreporthistorydetail from "../views/tipsreporthistory/tipsreporthistorydetail.vue";

/**
 * Platform Settings
 */

import Allsettings from "../views/platformsettings/allsettings.vue";

/**
 * tipsreporthistory
 */
import tipspointsale from "../views/tipspointsale/tipspointsale.vue";

/**
 * Novedades de Nomina
 */

import Novelties from "../views/payRollNews/novelties.vue";

import reporttips from "../views/reporttips/reporttips.vue";
import reporttipslinedeal from "../views/reporttips/reporttipslinedeal.vue";
import reporttipsdaily from "../views/reporttips/reporttipsdaily.vue";

//import reporttipsbodegasbbc from '../views/reporttips/reporttipsbodegasbbc.vue'
import reporttipsbodegasbbcdetail from "../views/reporttips/reporttipsbodegasbbcdetail.vue";
import reporttipsfriteartoisdetail from "../views/reporttips/reporttipsfriteartoisdetail.vue";
import reporttipsvistacoronadetail from "../views/reporttips/reporttipsvistacoronadetail.vue";
import tipspayrollnews from "../views/novelties/tipspayrollnews.vue";
import tipsfileUpload from "../views/tipsfileUpload/tipsfileUpload.vue";
import generalSiesaReport from "../views/generalsiesareport/GeneralSiesaReport.vue";
import enableShiftReports from "../views/enableShiftReports/enableShiftReports.vue";

/**
 * Health Tracker - Ausentismos
 */
import uploadFiles from "../views/OhSpecialits/uploadFiles.vue";
import detailAbsenteeism from "../views/OhAnalyst/detailAbsenteeism.vue";
import editAbsenteeism from "../views/OhAnalyst/editAbsenteeism.vue";

import employee from "../views/OhAnalyst/employee.vue";
import infoManagment from "../views/OhAnalyst/infoManagment.vue";
import resumeAbs from "../views/OhAnalyst/resumeAbs.vue";
import uploadPhotos from "../views/delegateUploadHT/uploadPhotos.vue";
import uploadPhones from "../views/delegateUploadHT/uploadPhones.vue";
import newPage from "../views/OhAnalyst/newPage.vue"; // newpage carlos
import absenteeismIndex from "../views/modules/health-tracker/V2/absenteeism/information-management"; // newpage carlos

/**
 * Health Tracker - SVE
 */
import sve from "../views/SVE/sve.vue";
import Diagnostic from "../views/SVE/diagnostic.vue";
import sveManagement from "../views/SVE/sveManagement.vue";
import GraficStatistics from "../views/SVE/GraficStatistics.vue";
// Salud Condition
import ExamenPage from '../views/SVE/saludCondition/ExamenPage.vue';
import MorbidityPage from '../views/SVE/saludCondition/MorbidityPage.vue';
//Salud Event
import CreateEventPage from '../views/SVE/saludEvent/CreateEventPage.vue';
/* Legal App */
import DashboardLegal from "../views/Legal/Dashboard";
import ProcessLegal from "../views/Legal/Process/view";
import CreateProcessLegal from "../views/Legal/Process/create";
import EditProcessLegal from "../views/Legal/Process/edit";
import EvaluateProcessLegal from "../views/Legal/Process/evaluate";
import HistoryProcessLegal from "../views/Legal/Process/history";
import IndicatorsLegal from "../views/Legal/Indicators";
import HelpLegal from "../views/Legal/Process/help";

// Modules
// Health Tracker
import healthTrackerSVEDiagnosticsRegister from "../router/modules/health-tracker/v2/sve/diagnostics-register/diagnostics-register-routes";
// Auth - SSO
import { sso } from "@/router/modules/auth/sso";
// ## routas de la version 2 de gestor de tiquetes
import { permisosSindicalesRequestV2Routes } from "@/router/modules/permisos-sindicales/requests/v2/requests";

// Middlewares
import auth from "@/middleware/auth";
// import guest from '@/middleware/guest'

Vue.use(VueRouter);

const routes = [
  // Home
  {
    path: "/",
    name: "HomeLogin",
    redirect: {
      name: "auth.sso",
    },
  },
  /**
   * Login
   */
  // {
  //   path: '/',
  //   name: 'HomeLogin',
  //   component: HomeLogin
  //   , meta: {
  //       middleware: [guest]
  //   }
  // },

  // {
  //   path: '/pwdrecovery',
  //   name: 'PwdRecovery',
  //   component: PwdRecovery
  //   , meta: {
  //       middleware: [auth]
  //       , roles: ['*']
  //   }
  // },
  //
  // {
  //   path: '/pwdchange',
  //   name: 'PwdChange',
  //   component: PwdChange
  //   , meta: {
  //       middleware: [auth]
  //       , roles: ['*']
  //   }
  // },

  // {
  //   path: '/emailrecovery',
  //   name: 'EmailRecovery',
  //   component: EmailRecovery
  // },

  /**
   * On boarding
   */
  {
    path: "/on-boarding",
    name: "HomeOnboarding",
    component: HomeOnboarding,
    meta: {
      middleware: [auth],
      roles: ["*"],
    },
  },
  {
    path: "/select-module",
    name: "SelectModule",
    component: SelectModule,
    meta: {
      middleware: [auth],
      roles: ["business-partner"],
    },
  },
  /**
   * Requests
   */
  {
    path: "/homerequest",
    name: "HomeRequest",
    component: HomeRequest,
    meta: {
      middleware: [auth],
      roles: ["solicitante-sindical"],
    },
  },
  {
    path: "/consulrequest/:id",
    name: "ConsulRequest",
    component: ConsulRequest,
    meta: {
      middleware: [auth],
      roles: ["solicitante-sindical", "business-partner", "relaciones-laborales"],
    },
  },
  /**
   * Demands
   */
  {
    path: "/solicitudes/:type?",
    name: "AllDemands",
    component: AllDemands,
    meta: {
      middleware: [auth],
      roles: [
        "solicitante-sindical",
        "relaciones-laborales",
        "business-partner",
        "aprobador",
        "gestor-impuestos",
      ],
    },
  },
  /**
   * DemandsBP
   */
  {
    path: "/solicitudes-bp/:type?",
    name: "AllDemandsBP",
    component: AllDemandsBP,
    meta: {
      middleware: [auth],
      roles: [
        "relaciones-laborales",
        "business-partner",
      ],
    },
  },
  /**
   * Dashboard
   */
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      middleware: [auth],
      roles: ["relaciones-laborales", "business-partner"],
    },
  },
  {
    path: "/dashboardPermisos",
    name: "dashboardPermisos",
    component: DashboardPermisos,
  },
  {
    path: "/dashboardDerechos",
    name: "DashboardDerechos",
    component: DashboardDerechos,
  },

  /**
   * Letter
   */
  {
    path: "/editletter",
    name: "EditLetter",
    component: EditLetter,
    meta: {
      middleware: [auth],
      roles: ["solicitante-sindical"],
    },
  },
  {
    path: "/templateletter",
    name: "TemplateLetter",
    component: TemplateLetter,
  },

  /**
   * Approval
   */
  {
    path: "/approverTks/:id",
    name: "Approval",
    component: Approval,
  },
  {
    path: "/approverSol/:id",
    name: "Approver",
    component: Approver,
    meta: {
      middleware: [auth],
      roles: ["aprobador", "business-partner"],
    },
  },

  /**
   * Free User
   */
  {
    path: "/freeuser/:cc",
    name: "FreeUser",
    component: FreeUser,
  },
  {
    path: "/inforequest/:id/:cc/:idUser",
    name: "InfoRequest",
    component: InfoRequest,
  },
  {
    path: "/absenteeism/:id/:cc",
    name: "absenteeism",
    component: Absenteeism,
  },

  /**
   * Help
   */
  {
    path: "/help",
    name: "help",
    component: Help,
    meta: {
      middleware: [auth],
      roles: ["*"],
    },
  },

  /**
   * Profile Admin
   */
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      middleware: [auth],
      roles: ["*"],
    },
  },

  /**
   * Settle
   */
  {
    path: "/settle",
    name: "settle",
    component: Settle,
    meta: {
      middleware: [auth],
      roles: ["radicacion"],
    },
  },

  /**
   * Right Petition
   */
  {
    path: "/rightpetition/:id",
    name: "rightpetition",
    component: RightPetition,
  },
  {
    path: "/reception",
    name: "reception",
    component: Reception,
  },
  {
    path: "/requestInfo",
    name: "requestInfo",
    component: RequestInfo,
  },
  {
    path: "/response",
    name: "response",
    component: Response,
  },
  {
    path: "/close",
    name: "close",
    component: Close,
  },
  {
    path: "/listrp",
    name: "listrp",
    component: listRP,
  },

  /**
   * Forum
   */
  {
    path: "/forum/:id/:id_forum/:email",
    name: "forum",
    component: Forum,
  },

  {
    path: "/informer/:email",
    name: "informer",
    component: Informer,
  },

  /**
   *
   *
   *
   * DISCIPLINARY PROCESSES
   *
   *
   *
   */
  {
    path: "/homeProcesses",
    name: "homeProcesses",
    component: HomeProcesses,
  },
  {
    path: "/process/:report/:id",
    name: "process",
    component: Process,
  },
  {
    path: "/processDetail/:id",
    name: "processDetail",
    component: ProcessDetail,
  },
  {
    path: "/processDashboard",
    name: "ProcessDashboard",
    component: ProcessDashboard,
  },
  {
    path: "/allProcess",
    name: "allProcess",
    component: AllProcess,
  },
  /**
   *
   *
   *
   * DISCIPLINARY PROCESSES
   *
   *
   *
   */
  /*  {
    path: '/homeProcesses',
    name: 'homeProcesses',
    component: HomeProcesses
  },
  {
    path: '/process/:report/:id',
    name: 'process',
    component: Process
  },
  {
    path: '/processDetail/:id',
    name: 'processDetail',
    component: ProcessDetail
  },
  {
    path: '/processDashboard',
    name: 'ProcessDashboard',
    component: ProcessDashboard
  },*/

  /**
   * Test
   */
  {
    path: "/test",
    name: "Test",
    component: Test,
  },
  /**
   * ShiftReport
   */
  {
    path: "/tipshiftReport",
    name: "tipshiftReport",
    component: tipshiftReport,
  },

  {
    path: "/tipshiftReport/:id/:fecha/:pdv",
    name: "tipshiftReportWithParameters",
    component: tipshiftReport,
  },
  /**
   * ShiftReport
   */
  {
    path: "/tipsreporthistory",
    name: "tipsreporthistory",
    component: tipsreporthistory,
  },
  /**
   * ShiftReport - Item
   */
  {
    path: "/tipsreporthistory/:id/:fecha/:pdv",
    name: "tipsreporthistory_item",
    component: tipsreporthistorydetail,
  },
  /** TipsEmployee
   */
  {
    path: "/tipsemployee",
    name: "tipsemployee",
    component: tipsemployee,
  },
  /**
  /**
  * Platform Setting
  */
  {
    path: "/allsettings",
    name: "allsettings",
    component: Allsettings,
  },

  {
    path: "/pointsale",
    name: "pointsale",
    component: tipspointsale,
  },
  /**
   * Novedades de Nomina
   */
  {
    path: "/novelties",
    name: "novelties",
    component: Novelties,
  },
  {
    path: "/reporttips",
    name: "reporttips",
    component: reporttips,
  },
  {
    path: "/reporttipsdaily/:id/:linedeal",
    name: "reporttipsdaily",
    component: reporttipsdaily,
  },
  {
    path: "/reporttipslinedeal/:id/:zona?",
    name: "reporttipslinedeal",
    component: reporttipslinedeal,
  },
  {
    path: "/reporttipsbodegasbbcdetail",
    name: "reporttipsbodegasbbcdetail",
    component: reporttipsbodegasbbcdetail,
  },
  {
    path: "/reporttipsfriteartoisdetail",
    name: "reporttipsfriteartoisdetail",
    component: reporttipsfriteartoisdetail,
  },
  {
    path: "/reporttipsvistacoronadetail",
    name: "reporttipsvistacoronadetail",
    component: reporttipsvistacoronadetail,
  },

  {
    path: "/tipspayrollnews",
    name: "tipspayrollnews",
    component: tipspayrollnews,
  },

  {
    path: "/tipsfileUpload",
    name: "tipsfileUpload",
    component: tipsfileUpload,
  },

  {
    path: "/generalsiesareport",
    name: "generalsiesareport",
    component: generalSiesaReport,
  },

  {
    path: "/habilitar-reportes-de-turno",
    name: "enableShiftReports",
    component: enableShiftReports,
  },

  /**
   * +++++++++++++++++++++ HEALTH TRACKER -- VP2 ---- +++++++++++++++++++++++++++
   */

  {
    path: "/uploadFiles",
    name: "uploadFiles",
    component: uploadFiles,
  },

  {
    path: "/employee",
    name: "employee",
    component: employee,
  },
  {
    path: "/detailAbsenteeism/:id",
    name: "detailAbsenteeism",
    component: detailAbsenteeism,
  },
  {
    path: "/editAbsenteeism/:id/:eid",
    name: "editAbsenteeism",
    component: editAbsenteeism,
  },
  {
    path: "/infoManagment",
    name: "infoManagment",
    component: infoManagment,
  },
  {
    path: "/resumeAbs",
    name: "resumeAbs",
    component: resumeAbs,
  },
  {
    path: "/uploadPhotos",
    name: "uploadPhotos",
    component: uploadPhotos,
  },
  {
    path: "/uploadPhones",
    name: "uploadPhones",
    component: uploadPhones,
  },
  {
    path: "/newPage", // newpage carlos
    name: "newPage",
    component: newPage,
  },
  {
    path: "/absenteeism-index",
    name: "absenteeismIndex",
    component: absenteeismIndex,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  /**
   * +++++++++++++++++++++ HEALTH TRACKER -- SVE ---- +++++++++++++++++++++++++++
   */

  {
    path: "/sve/:category/:type",
    name: "sve",
    component: sve,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/:ges",
    name: "sveges",
    component: sve,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/gestion-de-la-informacion",
    name: "GraficStatistics",
    component: GraficStatistics,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  
  {
    path: "/sveManagement",
    name: "sveManagement",
    component: sveManagement,
  },

  {
    path: "/detalle-ges/:id/:category/:type/:ipt",
    name: "detailSve",
    component: () => import("@/views/SVE/DetailGES.vue"),
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/formulario-ipt/:id/:employee_id/:ges_id/:category/:type",
    name: "formIPT",
    component: () => import("@/views/SVE/FormIPT.vue"),
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/detalle-formulario-ipt/:id/:employee_id/:ges_id/:is_detail",
    name: "detailFormIPT",
    component: () => import("@/views/SVE/FormIPT.vue"),
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/formulario-riesgo-potencial/:id/:category/:type",
    name: "formRisk",
    component: () => import("@/views/SVE/FormRisk.vue"),
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/actualizar-formulario-riesgo-potencial/:id/:category/:type/:is_edit",
    name: "editFormRisk",
    component: () => import("@/views/SVE/FormRisk.vue"),
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },

  /**
   * +++++++++++++++++++++ HEALTH TRACKER -- DIAGNOSTICS ---- +++++++++++++++++++++++++++
   */
  {
    path: "/diagnostic/:id",
    name: "Diagnostic",
    component: Diagnostic,
  },
    /**
   * +++++++++++++++++++++ HEALTH TRACKER -- Salud Condition ---- +++++++++++++++++++++++++++
   */
    {
      path: "/examen-medico-general-de-planta/:category/:type",
      name: "ExamenPage",
      component: ExamenPage,
    },
    {
      path: "/detalle-examen-medico-general-de-planta/:category/:type/:id",
      name: "DetailExamenPage",
      component: ExamenPage,
    },
    {
      path: "/encuesta-morbilidad-sentida/:category/:type",
      name: "MorbidityPage",
      component: MorbidityPage,
    },
    {
      path: "/detalle-encuesta-morbilidad-sentida/:category/:type/:id",
      name: "DetailMorbidityPage",
      component: MorbidityPage,
    },
     /**
   * +++++++++++++++++++++ HEALTH TRACKER -- Salud Condition ---- +++++++++++++++++++++++++++
   */
     {
      path: "/crear-evento/:category/:type",
      name: "CreateEventPage",
      component: CreateEventPage,
    },
  /********************* LEGAL APP ****************************************/
  {
    path: "/legal",
    name: "Legal App",
    component: DashboardLegal,
  },
  {
    path: "/legal/process",
    name: "Legal_process",
    component: ProcessLegal,
  },
  {
    path: "/legal/process/create",
    name: "Legal_process_create",
    component: CreateProcessLegal,
  },
  {
    path: "/legal/process/:id",
    name: "Legal_process_edit",
    component: EditProcessLegal,
  },
  {
    path: "/legal/process/evaluate/:id",
    name: "Legal_process_evaluate",
    component: EvaluateProcessLegal,
  },
  {
    path: "/legal/process/history/:id",
    name: "Legal_process_history",
    component: HistoryProcessLegal,
  },
  {
    path: "/legal/indicators",
    name: "Legal_indicators",
    component: IndicatorsLegal,
  },
  {
    path: "/legal/help",
    name: "Legal_help",
    component: HelpLegal,
  },
  {
    path: "/legal/documentation/:id",
    name: "Legal_documentation",
    component: () => import("@//views/Legal/Process/documentation/DocumentationProcess.vue"),
  },
  {
    path: "/legal/list-documentations/:id/:type",
    name: "Legal_list_documentation",
    component: () => import("@//views/Legal/Process/documentation/ListDocumentProcess.vue"),
  },
  {
    path: "/terminos-y-condiciones",
    name: "terminsandcondition",
    component: () => import("@/views/terminsandcondition/TerminsAndCondition"),
  },
  {
    path: "/error-:code",
    name: "errorPage",
    component: () => import("@/views/modules/common/errors/index.vue"),
    meta: {
      middleware: [auth],
      roles: ["*"],
    },
  },
  {
    path: "*",
    redirect: {
      name: "errorPage",
      params: { code: 404 },
    },
  },
];

const allRoutes = routes.concat(
  healthTrackerSVEDiagnosticsRegister,
  sso,
  permisosSindicalesRequestV2Routes
);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: allRoutes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, router, to };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  }
  return next();
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) {
    return context.next;
  }
  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

export default router;
